import script from "./Snackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=36f3e980&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f3e980"]])

export default __exports__